import { Link } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import { TypePageData } from '../_models/TypePage';
import { ArrowLeftIcon } from '../../assets/icons';
import useStyles from './styles';
interface Props {
  content: TypePageData;
  hideBackButton?: boolean;
  outsideBackLink?: string;
}

const ContentHeader = ({ content, hideBackButton = false, outsideBackLink }: Props) => {
  const { title, background, icon, Icon, backLink = "/" } = content;
  const classes = useStyles({ background });

  return (
    <Grid container component="section" className={classes.container}>
      <Grid container item xs={6} className={classes.textContainer}>
        <Typography variant="h1">
          {title}
        </Typography>
        {!hideBackButton &&
          <Button
            component={Link}
            to={!!outsideBackLink ? outsideBackLink : backLink}
            startIcon={<ArrowLeftIcon />}
            className={classes.button}
          >
            Voltar
          </Button>}
      </Grid>
      <Grid container item xs={6} className={classes.iconContainer}>
        {!!icon ?
          <img src={icon} alt={title} draggable="false" />
          :
          !!Icon && <Icon />
        }
      </Grid>
    </Grid>
  );
}

export default ContentHeader;